query adMaterials($input: GetAdMaterialsInput!) {
  adMaterials(input: $input) {
    materials {
      id
      type
      purpose
      mode
      campaignId
      landingpageId
      files {
        file {
          id
          url
          cdnUrl(named: true)
        }
        previewFile {
          id
          url
          cdnUrl
        }
      }
      version
      hasFile
      displayName
      createdAt
      updatedAt
    }
    topics {
      id
      name
      landingpageId
    }
    images {
      id
      url
      topicId
    }
    meta {
      total
      page
      itemsPerPage
      totalPages
    }
  }
}
